import { useExperimentParam } from 'src/utils/experimentNew'
import {
  getHydratedExperiment,
  useHydratedExperiment,
} from 'src/utils/hydrated-experiment'
import { type FeatureFlag } from '.'

export const useFeatureFlag = (name: FeatureFlag) => {
  const flag = useExperimentParam<'on' | 'off'>(name, 'off', {
    remoteOnly: true,
  })
  return flag === 'on'
}

/** SSR-safe hook — use instead of {@link useFeatureFlag} whenever the result branches the rendered tree. */
export const useHydratedFeatureFlag = (name: FeatureFlag): boolean => {
  const variant = useHydratedExperiment(name, { defaultValue: 'off' })
  return variant === 'on'
}

/** Imperative SSR-safe accessor (no hook). Returns `false` when no variant was injected. */
export const getHydratedFeatureFlag = (name: FeatureFlag): boolean => {
  return getHydratedExperiment(name) === 'on'
}
